export function formatTimestamp(isoString: string | null | undefined): string {
  if (!isoString) return "Never"
  // Ensure the string is treated as UTC by appending Z
  // if no timezone info is present
  const normalized =
    isoString.endsWith("Z") || isoString.includes("+")
      ? isoString
      : isoString + "Z"
  const date = new Date(normalized)
  const mm = String(date.getMonth() + 1).padStart(2, "0")
  const dd = String(date.getDate()).padStart(2, "0")
  const yyyy = date.getFullYear()
  let hours = date.getHours()
  const minutes = String(date.getMinutes()).padStart(2, "0")
  const ampm = hours >= 12 ? "PM" : "AM"
  hours = hours % 12 || 12
  return `${mm}/${dd}/${yyyy} ${hours}:${minutes} ${ampm}`
}

export function isStale(
  isoString: string | null | undefined,
  thresholdHours: number = 24
): boolean {
  if (!isoString) return true
  const diff = Date.now() - new Date(isoString).getTime()
  return diff > thresholdHours * 60 * 60 * 1000
}
